<ul class="search-container">
  <li class="search">
    <div class="search-wrapper card hoverable ms-hoverable">
      <input class="ms-search-input black-text" #inputQuery placeholder="{{placeholder}}" (keyup)="click$.next(inputQuery.value)">
      <i class="material-icons black-text" (click)="click$.next(inputQuery.value)">label_outline</i>
    </div>
  </li>
</ul>
